import { t } from '../../i18n/t';
import { useClientApp } from '../context';
import { dokumentePath } from '../dokumente/labels';
import { usePage, type Crumb } from '../page';
import { briefePath } from './labels';

// Titel, Pfad und Zurück-Ziel im Ordner Briefe: Start › Dokumente › <Firma> › Briefe › <Absender>.
// Mit nur einer Firma gibt es die Firmenwahl nicht, „Dokumente“ ist dann kein Link. Titel und sub kommen übersetzt.
export function useBriefePage(p: { title: string; clientId: string; clientName?: string; sub?: string }) {
  const { clients, clientName } = useClientApp();
  const one = clients.length === 1;
  const levels: Crumb[] = [
    { label: t('Start'), to: '/app' },
    { label: t('Dokumente'), to: one ? undefined : dokumentePath() },
    { label: p.clientName ?? clientName(p.clientId), to: dokumentePath(p.clientId) },
    { label: t('Briefe'), to: briefePath(p.clientId) },
  ];
  if (p.sub) levels.push({ label: p.sub });
  const last = levels.length - 1;
  const crumbs = levels.map((c, i) => (i === last ? { label: c.label } : c));
  usePage({ title: p.title, crumbs, back: levels[last - 1]!.to, nav: 'dokumente' });
}
